import React from 'react';
import { TouchableOpacity } from 'react-native';

import { Box, Text } from '../Restyle';
import Icon from '../shared/Icon/Icon';

type Props = {
  onPress?: () => void;
};

const EmptyStateNoFiles: React.FC<Props> = ({ onPress }) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      activeOpacity={onPress ? 0.7 : 1}
      disabled={!onPress}
      accessible={!!onPress}
      accessibilityRole={onPress ? 'button' : undefined}
      accessibilityLabel={onPress ? 'Upload files' : undefined}>
      <Box
        marginVertical='m'
        paddingVertical='m'
        justifyContent='center'
        borderRadius='m'
        backgroundColor='grey01'>
        <Box alignItems='center'>
          <Icon name='IlUpload' width={80} height={80} />
        </Box>

        <Box flexDirection='column' marginTop='xs'>
          <Text
            variant='webBodySecondary'
            textAlign='center'
            paddingBottom='xxs'>
            Drop files here or click to upload
          </Text>
          <Text variant='webBodyHintSubline' textAlign='center'>
            Supports image, video, and document files
          </Text>
        </Box>
      </Box>
    </TouchableOpacity>
  );
};

export default EmptyStateNoFiles;
